import { fetchPost } from "./common";

export interface AdvocacySubmissionResponse {
    deliveredMessages: DeliveredMessage[];
}

export interface DeliveredMessage {
    targetedId: number;
    deliveredId: number;
    destinationIds: number[];
}

export interface AdvocacyResponseContract {
    association: string
    userId: number
    messages: UserMessageContract[]
    signature: string
    defaultAddressType: string
}

export interface UserMessageContract {
    messageId: number
    targets: TargetDeliveryContract[]
    subject: string
    body: string
    complimentaryClose: string
}

export interface TargetDeliveryContract {
    type: string
    id: number
    deliveryMethod: string
    questionnaire: QuestionnaireItem[]
}

export interface QuestionnaireItem {
    question: string
    answer?: string
}

export interface ConfirmRequest {
    deliveredMessageIds: number
    smIds: number
    user: string;
    AddressType: string
    checksum: string
    city: string
    latitude: number
    longitude: number
    country: string
    county: string
    state: string
    streetAddress: string
    zipCode: string
    zipCodeExtension: string
}

export const postAdvocacyResponse = async (advocacyResponse: AdvocacyResponseContract, userToken: string) => {
    const url = `Advocacy/Responses?user=${userToken}`;
    const response = await fetchPost(url, advocacyResponse) as AdvocacySubmissionResponse;
    return response;
}